import { Card } from 'antd';
import styled from 'styled-components';

export const ShowWrapper = styled.div`
  .summary-container {
    padding: 10px;
    border-radius: 5px;
    background-color: #ffffff;
    border: 1px solid #efefef;
    &__data {
      padding: 5px 10px;
      background-color: #fafbfd;
      border-radius: 5px;
    }
  }
`;

export const CardWrapper = styled(Card)`
  .ant-card-body {
    padding: 10px 20px;
  }
  .ant-tabs-nav-wrap {
    width: 100% !important;
    .ant-tabs-nav-list {
      width: 100% !important;
    }
  }
  .ant-tabs-tab {
    flex: 1; /* Make each tab take an equal width */
  }

  .ant-tabs-tab {
    display: flex;
    justify-content: center; /* Center the tab text */
    align-items: center; /* Center the tab text vertically */
  }
`;
